import {add, format, parse} from 'date-fns'

export const formatDates = dates => {
	const formated = []
	for (const date of dates) {
		if(date !== null) {
			formated.push(format(date, 'yyyy-MM-dd'))
		}
	}
	return formated
}

export const formatSlot = slot => {
	const now = format(new Date(), 'yyyy-MM-dd')
	const custDtStart = new Date(`${now} ${slot.start}`);
	const custDtEnd = new Date(`${now} ${slot.end}`);
	return `${format(custDtStart, 'h:mm a')} - ${format(custDtEnd, 'h:mm a')}`
}

export const generateTimeArray = (startDate, endDate, intervalMinutes) => {
	const timeArray = [];
	let currentTime = startDate;
	
	while (currentTime < endDate) {
		timeArray.push(`${format(currentTime, 'hh:mm a')}-${format(add(currentTime, { minutes: intervalMinutes }), 'hh:mm a')}`);
		currentTime = add(currentTime, { minutes: intervalMinutes });
	}
	return timeArray;
}

export const generateRawTimeArray = (startDate, endDate, intervalMinutes) => {
	const timeArray = [];
	let currentTime = startDate;
	
	while (currentTime < endDate) {
		timeArray.push(`${format(currentTime, 'HH:mm:ss')}-${format(add(currentTime, { minutes: intervalMinutes }), 'HH:mm:ss')}`);
		currentTime = add(currentTime, { minutes: intervalMinutes });
	}
	return timeArray;
}

export const drawCircles = {
	id: 'drawСircles',
	afterUpdate(chart) {
		const arcs = chart.getDatasetMeta(0).data;
		
		arcs.forEach((arc) => {
			arc.round = {
				x: (chart.chartArea.left + chart.chartArea.right) / 2,
				y: (chart.chartArea.top + chart.chartArea.bottom) / 2,
				radius: (arc.outerRadius + arc.innerRadius) / 2,
				thickness: (arc.outerRadius - arc.innerRadius) / 2,
				backgroundColor: arc.options.backgroundColor,
			};
		});
	},
	afterDraw: (chart) => {
		const {
			ctx,
		} = chart;
		
		chart.getDatasetMeta(0).data.forEach((arc) => {
			const endAngle = Math.PI / 2 - arc.endAngle;
			
			ctx.save();
			ctx.translate(arc.round.x, arc.round.y);
			ctx.fillStyle = arc.options.backgroundColor;
			ctx.beginPath();
			ctx.arc(
				arc.round.radius * Math.sin(endAngle),
				arc.round.radius * Math.cos(endAngle),
				arc.round.thickness-1.2,
				0,
				arc.$context.parsed > 0 ? 2 * Math.PI : 0,
			);
			ctx.closePath();
			ctx.fill();
			ctx.restore();
		});
	},
}

export const centerTextPlugin = {
	id: 'centerTextPlugin',
	beforeDatasetsDraw: (chart, arg, plugins) => {
		const { ctx, data } = chart;
		
		const fontSize = chart.config.options.plugins.centerTextPlugin?.fontSize || 16;
		const centerText = chart.config.options.plugins.centerTextPlugin?.text || '';
		const color = chart.config.options.plugins.centerTextPlugin?.color || '#000';
		const dataColor = chart.config.options.plugins.centerTextPlugin?.dataColor || '#000';
		const centerData = chart.config.options.plugins.centerTextPlugin?.data !== undefined ? chart.config.options.plugins.centerTextPlugin?.data : '';
		
		const xCenter = chart.getDatasetMeta(0).data[0]?.x
		const yCenter = chart.getDatasetMeta(0).data[0]?.y
		
		ctx.save()
		ctx.translate(xCenter, yCenter)
		
		ctx.font = `bold 1.875rem Roboto`;
		ctx.textBaseline = 'bottom';
		ctx.textAlign = 'center';
		ctx.fillStyle = dataColor;
		ctx.fillText(centerData, 0, 0);
		
		ctx.font = `normal ${fontSize}px Roboto`;
		ctx.textBaseline = 'top';
		ctx.textAlign = 'center';
		ctx.fillStyle = color;
		ctx.fillText(centerText, 0, 10);
		
		ctx.restore()
	}
};

export const parseStationData = (stationStatistic, labels, rawLabels) => {
	const totalOrders = stationStatistic.total.total_orders
	const totalCost = stationStatistic.total.total_cost || 0
	const avgCost = stationStatistic.total.avg_cost_per_order || 0
	
	const shortest = `${stationStatistic.completion_time.shortest || 0} min`
	const longest = `${stationStatistic.completion_time.longest || 0} min`
	const average = `${stationStatistic.completion_time.average || 0} min`
	const trimmed_average = `${stationStatistic.completion_time.trimmed_average || 0} min`
	
	const totalPush = stationStatistic.notifications.push_count
	const totalEmail = stationStatistic.notifications.email_count
	const totalSms = stationStatistic.notifications.sms_count
	
	const pushPercent = Math.round(totalPush * 100 / totalOrders) || 0;
	const emailPercent = Math.round(totalEmail * 100 / totalOrders) || 0;
	const smsPercent = Math.round(totalSms * 100 / totalOrders) || 0;
	
	const parsedData = [
		{ label: 'Push', value: pushPercent, color: '#48CDCE' },
		{ label: 'Email', value: emailPercent, color: '#FBD047' },
		{ label: 'Text Msg', value: smsPercent, color: '#9053AF' }
	];
	
	const data = {
		labels: parsedData.map((item) => item.label),
		datasets: [
			{
				data: parsedData.map((item) => item.value),
				backgroundColor: parsedData.map((item) => item.color),
				hoverBackgroundColor: parsedData.map((item) => item.color)
			}
		]
	};
	const options = {
		cutout: '70%',
		hover: {mode: null},
		plugins: {
			centerTextPlugin: {
				data: totalOrders,
				dataColor: '#303030',
				text: 'Total Orders',
				fontSize: 14,
				color: '#7B7B7B'
			},
			tooltip: {
				enabled: false
			},
			legend: {
				display: false,
			}
		},
	};
	
	const intervals = stationStatistic.intervals
	
	const documentStyle = getComputedStyle(document.documentElement);
	const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
	const surfaceBorder = documentStyle.getPropertyValue('--surface-border');
	
	const numbers = new Array(labels.length).fill(0)
	
	let maxOrdersPerIntervals = 0;
	
	for(const value of intervals) {
		const idx = (rawLabels.findIndex(function(item){
			return item.indexOf(`${value.interval}-`)!==-1;
		}));
		numbers[idx] = value.orders;
		if(value.orders > maxOrdersPerIntervals)
			maxOrdersPerIntervals = value.orders;
	}
	
	const maxY = (1 + 10/100) * maxOrdersPerIntervals;
	const step = maxOrdersPerIntervals * 25 / 100;
	const min = maxY / 4;
	const medium = maxY / 2;
	const high = (maxY / 4) * 3;
	
	const backgroundColors = []
	
	for (let i = 0; i < numbers.length; i++) {
		if(numbers[i]>=0 && numbers[i]<=min)
			backgroundColors.push('#D9D9D9')
		if(numbers[i]>min && numbers[i]<=medium)
			backgroundColors.push('#FFC44E')
		if(numbers[i]>medium && numbers[i]<=high)
			backgroundColors.push('#FF8F3F')
		if(numbers[i]>high)
			backgroundColors.push('#C43908')
	}
	
	const barData = {
		labels,
		datasets: [
			{
				backgroundColor: backgroundColors,
				borderColor: backgroundColors,
				data: numbers,
				borderRadius: 50,
				barThickness: 30
			},
		]
	}
	
	const barOptions = {
		maintainAspectRatio: false,
		aspectRatio: 0.8,
		plugins: {
			tooltip: {
				enabled: true,
				callbacks: {
					label: function(tooltipItem, data) {
						tooltipItem.formattedValue = `Orders: ${tooltipItem.raw}`
					}
				}
			},
			legend: {
				display: false,
			},
			datalabels: {
				color: '#fff',
				anchor: 'end',
				align: 'start',
			}
		},
		scales: {
			x: {
				ticks: {
					autoSkip: false,
					callback: function(value, index, ticks) {
						const label = this.getLabelForValue(value);
						return label.split('-');
					},
					font: {
						size: 14
					},
					color: '#888'
				},
			},
			y: {
				min: 0,
				max: maxY,
				ticks: {
					count: 5,
					maxTicksLimit: 5,
					beginAtZero: true,
					autoSkip: false,
					stepSize: step,
					color: textColorSecondary
				},
				grid: {
					color: surfaceBorder,
					drawBorder: false
				}
			}
		}
	}
	
	return {
		data,
		options,
		parsedData,
		totalCost,
		avgCost,
		shortest,
		longest,
		average,
		trimmed_average,
		barData,
		barOptions,
		menu: stationStatistic.options
	}
}

export const parseStationsData = stationsStatistic => {
	const totalOrders = stationsStatistic.length > 0 ? stationsStatistic.reduce((acc, cur) => acc + cur.total_orders, 0) : 0;
	const totalPush = stationsStatistic.reduce((acc, cur) => acc + cur.push_count, 0);
	const totalEmail = stationsStatistic.reduce((acc, cur) => acc + cur.email_count, 0);
	const totalSms = stationsStatistic.reduce((acc, cur) => acc + cur.sms_count, 0);
	
	const pushPercent = Math.round(totalPush * 100 / totalOrders) || 0;
	const emailPercent = Math.round(totalEmail * 100 / totalOrders) || 0;
	const smsPercent = Math.round(totalSms * 100 / totalOrders) || 0;
	
	const parsedData = [
		{ label: 'Push', value: pushPercent, color: '#48CDCE' },
		{ label: 'Email', value: emailPercent, color: '#FBD047' },
		{ label: 'Text Msg', value: smsPercent, color: '#9053AF' }
	];
	
	const data = {
		labels: parsedData.map((item) => item.label),
		datasets: [
			{
				data: parsedData.map((item) => item.value),
				backgroundColor: parsedData.map((item) => item.color),
				hoverBackgroundColor: parsedData.map((item) => item.color)
			}
		]
	};
	const options = {
		cutout: '70%',
		hover: {mode: null},
		plugins: {
			centerTextPlugin: {
				data: totalOrders,
				dataColor: '#303030',
				text: 'Total Orders',
				fontSize: 14,
				color: '#7B7B7B'
			},
			tooltip: {
				enabled: false
			},
			legend: {
				display: false,
			}
		},
	};

	const totalCost = stationsStatistic.reduce((acc, cur) => acc + parseFloat(cur.total_cost), 0).toFixed(2)
	const avg = totalCost / totalOrders
	
	return {
		data,
		options,
		parsedData,
		totalCost,
		avgCost: avg ? avg.toFixed(2) : '0.00'
	}
}